import { NgfrTicgnExonerationViewModel, PwfrTicfeExonerationViewModel, VatExonerationViewModel } from '@ng-gems/api/midback';

import { ApiOptions } from '../../api-options.decorator';
import { ParamsAdapter } from '../../params.adapter';

import { ApiBaseMidBack } from './base';

export class ApiTaxExoneration extends ApiBaseMidBack {
  @ApiOptions({ channel: 'logisticExonerationTicgnGet' })
  getTicgnExoneration(gridOperator: string, meteringPoint: string, params: ParamsAdapter) {
    return this.get<NgfrTicgnExonerationViewModel[]>(`/exoneration/ngfr_ticgn_exoneration/${gridOperator}/${meteringPoint}`, params);
  }

  @ApiOptions({ channel: 'logisticExonerationTicfeGet' })
  getTicfeExoneration(gridOperator: string, meteringPoint: string, params: ParamsAdapter) {
    return this.get<PwfrTicfeExonerationViewModel[]>(`/exoneration/pwfr_ticfe_exoneration/${gridOperator}/${meteringPoint}`, params);
  }

  @ApiOptions({ channel: 'logisticVatExoneration' })
  getVatExoneration(gridOperator: string, meteringPoint: string, params: ParamsAdapter) {
    return this.get<VatExonerationViewModel[]>(`/exoneration/vat_exoneration/${gridOperator}/${meteringPoint}`, params);
  }
}
